var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call (37) 1",
    clipPath: "url(#clip0_13_7078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4963 24.2591C26.632 26.8855 23.2459 28.1959 20.8267 27.9775C17.5227 27.6789 13.9275 25.9261 11.1984 23.9959C7.18698 21.1586 3.42938 16.7701 1.23978 12.1127C-0.307691 8.82179 -0.654891 4.77485 1.64671 1.77512C2.49791 0.666321 3.42004 0.0745879 4.80138 0.00552122C6.72031 -0.0878121 6.98911 1.00979 7.64804 2.71965C8.13898 3.99832 8.79418 5.30312 9.16004 6.62845C9.84511 9.10179 7.45018 9.20445 7.14778 11.2261C6.96111 12.501 8.50484 14.2109 9.20298 15.1199C10.5486 16.8904 12.1968 18.409 14.0712 19.6055C15.1352 20.2757 16.8488 21.4834 18.0659 20.817C19.94 19.7903 19.7646 16.6301 22.3835 17.6997C23.7406 18.2522 25.0547 19.0493 26.3502 19.7474C28.3531 20.8245 28.2598 21.9407 27.4963 24.2591C28.0675 22.5269 26.9251 25.9914 27.4963 24.2591Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_7078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.29500ecc2d47e996fdeebddda5dabf19.svg";
export { ForwardRef as ReactComponent };